<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aZVgR/tc-custom/9781466820104.jpg?1732163165177" alt="This image is the cover for the book All We Know"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All We Know
      </h1>
      <p class="bookDescription body article font2">
        <p>Esther Murphy was a brilliant New York intellectual who dazzled friends and strangers with an unstoppable flow of conversation. But she never finished the books she was contracted to write—a painful failure and yet a kind of achievement.<br/><br/>The quintessential fan, Mercedes de Acosta had intimate friendships with the legendary actresses and dancers of the twentieth century. Her ephemeral legacy lies in the thousands of objects she collected to preserve the memory of those performers and to honor the feelings they inspired.<br/><br/>An icon of haute couture and a fashion editor of British <i>Vogue</i>, Madge Garland held bracing views on dress that drew on her feminism, her ideas about modernity, and her love of women. Existing both vividly and invisibly at the center of cultural life, she—like Murphy and de Acosta—is now almost completely forgotten.<br/><br/>In <i>All We Know</i>, Lisa Cohen describes these women's glamorous choices, complicated failures, and controversial personal lives with lyricism and empathy. At once a series of intimate portraits and a startling investigation into style, celebrity, sexuality, and the genre of biography itself, <i>All We Know</i> explores a hidden history of modernism and pays tribute to three compelling lives. <br/><b><i>All We Know </i>is one of <i>Publishers Weekly</i>'s Top 10 Best Books of 2012</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Cohen
      </h2>
      
      <p class="authorDescription body article"><B>Lisa Cohen</B>’s <I>All We Know: Three Lives</I> was a finalist for the National Book Critics Circle award and the PEN/Bograd Weld prize, and a <I>New York Times</I> Notable Book and Editor’s Choice for 2012. Her writing has appeared in <I>BOMB</I>, <I>The New York Times</I>, <I>Vogue</I>, <I>The Paris Review</I>, <I>The New Yorker</I>, <I>Women in Clothes</I>, and many other journals and anthologies. She teaches at Wesleyan University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b73f1616